import CityPageTemplate from "../city-template/CityPageTemplate";
import { soldotnaConfig } from "./data";

export default function SoldotnaPage() {
  return <CityPageTemplate config={soldotnaConfig} />;
}